export let PictureMode;
(function (PictureMode) {
  PictureMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
  PictureMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
  PictureMode["COVER"] = "COVER";
  PictureMode["CONTAIN"] = "CONTAIN";
})(PictureMode || (PictureMode = {}));
//# sourceMappingURL=picture.types.js.map